import { render, staticRenderFns } from "./Lb.vue?vue&type=template&id=6bc83f54&"
import script from "./Lb.vue?vue&type=script&lang=js&"
export * from "./Lb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports